export default __webpack_public_path__ + "static/FlexeetLogo-a054892ccb0d71b4aaa4577ee48b73f1.svg";